import React from 'react';
import styles from './SectionHeader.module.scss';

export interface ISectionHeaderProps {
  title: string;
  description?: string;
  /** Optional trailing content (e.g. a status badge). */
  aside?: React.ReactNode;
}

/** Card section header: overline title + optional description. */
export default function SectionHeader({
  title,
  description,
  aside,
}: ISectionHeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.text}>
        <h2 className={styles.title}>{title}</h2>
        {description ? (
          <p className={styles.description}>{description}</p>
        ) : null}
      </div>
      {aside}
    </header>
  );
}
